import plans from '@api/plans'
import { GET_PLANS_SUCCESS, GET_PLANS_FAILURE } from './_types'

const getDefaultState = () => {
  return {
    getPlansCompleted: false,
    availablePlans: [],
  }
}

export const state = getDefaultState()

export const getters = {
  /**
   * Returns A Plan object corresponding to the provided ID
   */
  getPlanItemByID: (state) => (id) => {
    return state.availablePlans.find((obj) => {
      return obj.id === id
    })
  },
  getNextPlanItemByCurrentPlanID: (state) => (plan) => {
    return state.availablePlans.find((obj) => {
      return (
        plan.currency === obj.currency &&
        plan.billingPeriod === obj.billingPeriod &&
        parseFloat(parseFloat(obj.price).toFixed(2)) >
        parseFloat(parseFloat(plan.price).toFixed(2))
      )
    })
  },
  getPlanItemsByCurrencyAndBillingPeriod: (state) => (
    currency, billingPeriod) => {
    return state.availablePlans.filter((plan) => {
      return (
        (plan.currency.toLowerCase().includes(currency) &&
          plan.billingPeriod.toLowerCase().includes(billingPeriod)) ||
        plan.id === 'basic'
      )
    })
  },
}

export const mutations = {
  [GET_PLANS_SUCCESS](state, response) {
    state.availablePlans = response.data
    state.getPlansCompleted = true
  },
  [GET_PLANS_FAILURE](state) {
    state.getPlansCompleted = false
  },
}

export const actions = {
  getAvailablePlans({ commit, state }) {
    // Check if we have already retrieved plans
    if (state.getPlansCompleted) {
      return Promise.resolve(state.availablePlans)
    }

    // Retrieve plans
    return plans.getAvailablePlans().then((response) => {
      commit(GET_PLANS_SUCCESS, response)
    }).catch(() => { commit(GET_PLANS_FAILURE) })
  },
  getProrationAmount({ commit }, payload) {
    return plans.getProrationAmount(payload)
  },
}
